import { usePathAndData } from "../../../hook/usePathAndData"; // Hook para obtener el path y los datos relacionados.
import { AppLayout } from "../../layout/AppLayout"; // Componente de diseño principal.
import { CrearCopia } from "../../view/Eventos/CrearCopia";
import { CrearEvento } from "../../view/Eventos/CrearEvento";
import { EditarEvento } from "../../view/Eventos/EditarEvento";

/**
 * Componente de la página de calendario.
 * Renderiza diferentes vistas del calendario según el path actual.
 */
export const PageEventos = () => {
    const { path } = usePathAndData(); // Obtiene el path actual utilizando el hook personalizado.

    return (
        <AppLayout>
            {" "}
            {/* Contenedor principal con diseño de la aplicación. */}
            <div className="pc-container">
                <div className="pc-content">
                    <div className="row">
                        <div className="card">
                            <div className="card-body" style={{ borderRadius: "13px" }}>
                                {/* Renderiza la lista del calendario si el path es 'calendario/lista'. */}
                                {path[1] === "evento" && path[2] === "crear" && <CrearEvento />}
                                {path[1] === "evento" && path[2] === "ver" && <EditarEvento />}
                                {path[1] === "evento" && path[2] === "copia" && <CrearCopia />}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AppLayout>
    );
};
